import styles from '../../css/Privacy.module.css';

function TermsOfService() {
  return (
    <main className="centeredHorizontallyOnMobile" aria-labelledby="tos-title">
      <article className={styles.contentContainer}>
        <h1 id="tos-title" className={styles.pageTitle}>Terms of Service</h1>

        <p className={styles.lastUpdated}>
          Last updated: <time dateTime="2025-07-26">26 July 2025</time>
        </p>

        <p>
          By using this website (lawrenceluo.me), purchasing products, or downloading any content,
          you agree to the following terms:
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>1. Overview</h2>

        <p className={styles.multiParagraph}>
          This site is owned and operated by Lawrence Luo. It offers music transcriptions and arrangements
          as digital downloads. These Terms govern your access to and use of the website, products, and services. If you do not agree with these Terms, please do not use the site.
        </p>

        <p className={styles.multiParagraph}>
          While I strive to ensure the accuracy of all information on this website, including product descriptions and pricing, I do not warrant that all information is complete, accurate, or current. I reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.
        </p>

        <p className={styles.multiParagraph}>
          This website may contain links to third-party websites or services that are not owned or controlled by Lawrence Luo. I have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that Lawrence Luo shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such websites or services.
        </p>


        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>2. Products and Licensing</h2>

        <p>
          All products are sold as digital files, including but not limited to sheet music, transcriptions, and arrangements. When you purchase a transcription:
        </p>
        <ul className={styles.bulletList}>
          <li>You are granted a personal, non-transferable, non-commercial license to use the file.</li>
          <li>You may not resell, redistribute, or publicly post the files.</li>
          <li>You may print or use the files for your own practice, performance, or personal enjoyment.</li>
        </ul>
        <p className={styles.multiParagraph}>You acknowledge that many of the arrangements and transcriptions offered on this site are based on original works that may be protected by copyright. By purchasing, you understand that your license pertains only to the specific arrangement or transcription provided by Lawrence Luo and does not grant you rights to the underlying original musical composition, which remains the property of its respective copyright holder(s).</p>

        <p className={styles.multiParagraph}>It is your responsibility to ensure you have any necessary licenses or permissions for any public performance or commercial use of the underlying original work.        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>3. Payments and Order Processing</h2>

        <p>
          Payments are securely processed via Stripe. I do not store or access your credit card details.
        </p>

        <p>Upon successful payment:</p>
        <ul className={styles.bulletList}>
          <li>A download link will be made available.</li>
          <li>Files will remain available for download for 30 days.</li>
        </ul>

        <p>
          If you encounter any issue with your download, please contact me promptly via email.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>4. Refund Policy</h2>

        <p>
          All sales are final. Due to the digital nature of the products, no refunds, returns, or exchanges
          are offered once a purchase is completed. If a file is corrupted or cannot be accessed, I will be happy to provide a working copy.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>5. Intellectual Property</h2>

        <p>
          All content on this site, including transcriptions, arrangements, branding, and design, is the intellectual property of Lawrence Luo unless otherwise credited. Unauthorized copying, distribution, or commercial use is prohibited.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>6. User Conduct</h2>

        <p>By using this website, you agree not to:</p>
        <ul className={styles.bulletList}>
          <li>Attempt to interfere with or disrupt the site</li>
          <li>Use content for any unlawful or unauthorized purpose</li>
          <li>Share your personal download link with others</li>
          <li>Re-upload content that you purchased from this website to share with others</li>
        </ul>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>7. Limitation of Liability</h2>

        <p>
          I make every effort to provide accurate and high-quality digital products. However, I am not liable for:
        </p>
        <ul className={styles.bulletList}>
          <li>Any damage or loss resulting from the use or inability to use the files</li>
          <li>Incompatibility issues with software or devices</li>
        </ul>

        <p>
          All services and content are provided &quot;as is&quot; without warranties of any kind.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>8. Governing Law</h2>

        <p>
          These Terms are governed by the laws of the State of California, United States, without regard to
          its conflict of law provisions.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>9. Contact</h2>

        <p>
          If you have questions about these terms, please reach out to <a href="mailto:luolawrence1@gmail.com">luolawrence1@gmail.com</a>.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>10. Changes to Terms</h2>
        <p>
          I reserve the right, at my sole discretion, to modify or replace these Terms at any time. If a revision is material, I will try to provide at least 30 days&apos; notice prior to any new terms taking effect. What constitutes a material change will be determined at my sole discretion. By continuing to access or use my website after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the website.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>11. Indemnification</h2>
        <p>
          You agree to defend, indemnify and hold harmless Lawrence Luo and his licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney&apos;s fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your account and password; b) a breach of these Terms, or c) Content posted on the Service.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>12. Severability</h2>
        <p>
          If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.
        </p>

        <hr className={styles.divider} />

        <h2 className={styles.sectionTitle}>13. Waiver</h2>
        <p>
          No waiver of any term or condition set forth in these Terms of Service shall be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of Lawrence Luo to assert a right or provision under these Terms of Service shall not constitute a waiver of such right or provision.
        </p>

      </article>
    </main>
  );
}

export default TermsOfService;